import { useState, useEffect, useRef } from "react";

const useSessionTimeout = (
  isLoggedIn,
  initialTimeout = 3600,
  onSessionExpire = () => {}
) => {
  const [sessionExpire, setSessionExpire] = useState(false);
  const timeoutRef = useRef(initialTimeout);
  const timerRef = useRef(null);

  const resetTimer = () => {
    if (!isLoggedIn) return;
    timeoutRef.current = initialTimeout;
    localStorage.setItem("lastActivity", Date.now().toString());
    localStorage.setItem("sessionExpired", JSON.stringify(false));
    startTimer();
  };

  const startTimer = () => {
    if (!isLoggedIn || timerRef.current) return;
    stopTimer(); // Clear any previous timer before starting a new one

    timerRef.current = setInterval(() => {
      const lastActivity = parseInt(
        localStorage.getItem("lastActivity") || Date.now().toString(),
        10
      );
      const timeSinceLastActivity = Math.floor(
        (Date.now() - lastActivity) / 1000
      );

      timeoutRef.current = initialTimeout - timeSinceLastActivity;

      if (timeoutRef.current <= 0) {
        clearInterval(timerRef.current);
        timerRef.current = null;
        setSessionExpire(true);
        localStorage.setItem("sessionExpired", JSON.stringify(true));
        onSessionExpire();
      }
    }, 1000);
  };

  const stopTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      // **Fix:** Reset session state when logging in
      setSessionExpire(false);
      localStorage.setItem("sessionExpired", JSON.stringify(false));
      resetTimer();

      const handleUserActivity = () => resetTimer();

      document.addEventListener("keydown", handleUserActivity);
      document.addEventListener("mousemove", handleUserActivity);
      document.addEventListener("visibilitychange", resetTimer);

      return () => {
        document.removeEventListener("keydown", handleUserActivity);
        document.removeEventListener("mousemove", handleUserActivity);
        document.removeEventListener("visibilitychange", resetTimer);
        stopTimer();
      };
    } else {
      stopTimer();
      setSessionExpire(false);
      localStorage.setItem("sessionExpired", JSON.stringify(false)); // Reset on logout
    }
  }, [isLoggedIn]);

  return { sessionExpire };
};

export default useSessionTimeout;

// import { useState, useEffect, useRef } from "react";

// const useSessionTimeout = (
//   isLoggedIn,
//   initialTimeout = 600,
//   onSessionExpire = () => {}
// ) => {
//   const [sessionExpire, setSessionExpire] = useState(
//     JSON.parse(localStorage.getItem("sessionExpired")) || false
//   );
//   const timeoutRef = useRef(initialTimeout);
//   const timerRef = useRef(null);

//   const resetTimer = () => {
//     if (!isLoggedIn) return;
//     timeoutRef.current = initialTimeout;
//     localStorage.setItem("lastActivity", Date.now().toString());
//     localStorage.setItem("sessionExpired", JSON.stringify(false)); // Reset session expiry flag
//     startTimer();
//   };

//   const startTimer = () => {
//     if (!isLoggedIn || timerRef.current) return;
//     stopTimer();
//     timerRef.current = setInterval(() => {
//       const lastActivity = parseInt(localStorage.getItem("lastActivity") || Date.now().toString(), 10);
//       const timeSinceLastActivity = Math.floor((Date.now() - lastActivity) / 1000);

//       timeoutRef.current = initialTimeout - timeSinceLastActivity;

//       if (timeoutRef.current <= 0) {
//         clearInterval(timerRef.current);
//         timerRef.current = null;
//         setSessionExpire(true);
//         localStorage.setItem("sessionExpired", JSON.stringify(true)); // Persist expiration status
//         onSessionExpire();
//       }
//     }, 1000);
//   };

//   const stopTimer = () => {
//     if (timerRef.current) {
//       clearInterval(timerRef.current);
//       timerRef.current = null;
//     }
//   };

//   const handleVisibilityChange = () => {
//     if (!isLoggedIn) return;

//     if (document.hidden) {
//       localStorage.setItem("sleepStartTime", Date.now().toString());
//     } else {
//       const sleepStartTime = parseInt(localStorage.getItem("sleepStartTime") || "0", 10);
//       const currentTime = Date.now();

//       if (sleepStartTime > 0 && (currentTime - sleepStartTime) / 1000 >= initialTimeout) {
//         setSessionExpire(true);
//         localStorage.setItem("sessionExpired", JSON.stringify(true));
//         onSessionExpire();
//       }

//       localStorage.removeItem("sleepStartTime");
//       startTimer();
//     }
//   };

//   useEffect(() => {
//     if (isLoggedIn) {
//       const handleUserActivity = () => resetTimer();

//       localStorage.setItem("tabCount", (parseInt(localStorage.getItem("tabCount") || "0") + 1).toString());

//       // Check if session was already expired before reload
//       const lastActivity = parseInt(localStorage.getItem("lastActivity") || "0", 10);
//       const timeSinceLastActivity = Math.floor((Date.now() - lastActivity) / 1000);

//       if (timeSinceLastActivity < initialTimeout) {
//         // Restore session if within valid timeframe
//         setSessionExpire(false);
//         localStorage.setItem("sessionExpired", JSON.stringify(false));
//         startTimer();
//       } else {
//         setSessionExpire(true);
//         localStorage.setItem("sessionExpired", JSON.stringify(true));
//         onSessionExpire();
//       }

//       document.addEventListener("keydown", handleUserActivity);
//       document.addEventListener("mousemove", handleUserActivity);
//       document.addEventListener("visibilitychange", handleVisibilityChange);

//       const handleTabClose = () => {
//         const currentTabCount = parseInt(localStorage.getItem("tabCount") || "1", 10);
//         if (currentTabCount <= 1) {
//           localStorage.setItem("tabCount", "0");
//           onSessionExpire();
//         } else {
//           localStorage.setItem("tabCount", (currentTabCount - 1).toString());
//         }
//       };

//       window.addEventListener("beforeunload", handleTabClose);
//       window.addEventListener("storage", (event) => {
//         if (event.key === "tabCount" && event.newValue === "0") {
//           onSessionExpire();
//         }
//       });

//       return () => {
//         document.removeEventListener("keydown", handleUserActivity);
//         document.removeEventListener("mousemove", handleUserActivity);
//         document.removeEventListener("visibilitychange", handleVisibilityChange);

//         window.removeEventListener("beforeunload", handleTabClose);
//         stopTimer();
//       };
//     } else {
//       stopTimer();
//       setSessionExpire(false);
//     }
//   }, [isLoggedIn]);

//   return { sessionExpire };
// };

// export default useSessionTimeout;

// Last final Product 1 bug reload

// import { useState, useEffect, useRef } from "react";

// const useSessionTimeout = (
//   isLoggedIn,
//   initialTimeout = 600,
//   onSessionExpire = () => {}
// ) => {
//   const [sessionExpire, setSessionExpire] = useState(false);
//   const timeoutRef = useRef(initialTimeout);
//   const timerRef = useRef(null);

//   const resetTimer = () => {
//     if (!isLoggedIn) return;
//     timeoutRef.current = initialTimeout;
//     localStorage.setItem("lastActivity", Date.now().toString());
//     startTimer();
//   };

//   const startTimer = () => {
//     if (!isLoggedIn || timerRef.current) return;
//     stopTimer();
//     timerRef.current = setInterval(() => {
//       const lastActivity = parseInt(localStorage.getItem("lastActivity") || Date.now().toString(), 10);
//       const timeSinceLastActivity = Math.floor((Date.now() - lastActivity) / 1000);

//       timeoutRef.current = initialTimeout - timeSinceLastActivity;

//       if (timeoutRef.current <= 0) {
//         clearInterval(timerRef.current);
//         timerRef.current = null;
//         setSessionExpire(true);
//         onSessionExpire();
//       }
//     }, 1000);
//   };

//   const stopTimer = () => {
//     if (timerRef.current) {
//       clearInterval(timerRef.current);
//       timerRef.current = null;
//     }
//   };

//   const handleVisibilityChange = () => {
//     if (!isLoggedIn) return;

//     if (document.hidden) {
//       // Laptop is locked or sleeping, store timestamp
//       localStorage.setItem("sleepStartTime", Date.now().toString());
//     } else {
//       // Laptop woke up or unlocked
//       const sleepStartTime = parseInt(localStorage.getItem("sleepStartTime") || "0", 10);
//       const currentTime = Date.now();

//       if (sleepStartTime > 0 && (currentTime - sleepStartTime) / 1000 >= initialTimeout) {
//         // If laptop was locked for longer than the timeout, expire the session
//         setSessionExpire(true);
//         onSessionExpire();
//       }

//       localStorage.removeItem("sleepStartTime");
//       startTimer();
//     }
//   };

//   useEffect(() => {
//     if (isLoggedIn) {
//       const handleUserActivity = () => resetTimer();

//       // Track the number of open tabs
//       localStorage.setItem("tabCount", (parseInt(localStorage.getItem("tabCount") || "0") + 1).toString());

//       startTimer();
//       localStorage.setItem("lastActivity", Date.now().toString());

//       document.addEventListener("keydown", handleUserActivity);
//       document.addEventListener("mousemove", handleUserActivity);
//       document.addEventListener("visibilitychange", handleVisibilityChange);

//       const handleTabClose = () => {
//         const currentTabCount = parseInt(localStorage.getItem("tabCount") || "1", 10);
//         if (currentTabCount <= 1) {
//           localStorage.setItem("tabCount", "0"); // Reset count
//           onSessionExpire(); // Expire session only if it's the last tab
//         } else {
//           localStorage.setItem("tabCount", (currentTabCount - 1).toString());
//         }
//       };

//       window.addEventListener("beforeunload", handleTabClose);
//       window.addEventListener("storage", (event) => {
//         if (event.key === "tabCount" && event.newValue === "0") {
//           onSessionExpire(); // If another tab set count to 0, expire session
//         }
//       });

//       return () => {
//         document.removeEventListener("keydown", handleUserActivity);
//         document.removeEventListener("mousemove", handleUserActivity);
//         document.removeEventListener("visibilitychange", handleVisibilityChange);

//         window.removeEventListener("beforeunload", handleTabClose);
//         stopTimer();
//       };
//     } else {
//       stopTimer();
//       setSessionExpire(false);
//     }
//   }, [isLoggedIn]);

//   return { sessionExpire };
// };

// export default useSessionTimeout;

// import { useState, useEffect, useRef } from "react";

// const useSessionTimeout = (
//   isLoggedIn,
//   initialTimeout = 60,
//   onSessionExpire = () => {}
// ) => {
//   const [sessionExpire, setSessionExpire] = useState(false);
//   const timeoutRef = useRef(initialTimeout);
//   const timerRef = useRef(null);

//   const resetTimer = () => {
//     if (!isLoggedIn) return;
//     timeoutRef.current = initialTimeout;
//     localStorage.setItem("lastActivity", Date.now().toString());
//     startTimer();
//   };

//   const startTimer = () => {
//     if (!isLoggedIn || timerRef.current) return;
//     stopTimer();
//     timerRef.current = setInterval(() => {
//       const lastActivity = parseInt(localStorage.getItem("lastActivity") || Date.now().toString(), 10);
//       const timeSinceLastActivity = Math.floor((Date.now() - lastActivity) / 1000);

//       timeoutRef.current = initialTimeout - timeSinceLastActivity;

//       if (timeoutRef.current <= 0) {
//         clearInterval(timerRef.current);
//         timerRef.current = null;
//         setSessionExpire(true);
//         onSessionExpire();
//       }
//     }, 1000);
//   };

//   const stopTimer = () => {
//     if (timerRef.current) {
//       clearInterval(timerRef.current);
//       timerRef.current = null;
//     }
//   };

//   const handleVisibilityChange = () => {
//     if (!isLoggedIn) return;
//     if (!document.hidden) {
//       startTimer();
//     } else {
//       stopTimer();
//     }
//   };

//   useEffect(() => {
//     if (isLoggedIn) {
//       const handleUserActivity = () => resetTimer();

//       // Track the number of open tabs
//       localStorage.setItem("tabCount", (parseInt(localStorage.getItem("tabCount") || "0") + 1).toString());

//       startTimer();
//       localStorage.setItem("lastActivity", Date.now().toString());

//       document.addEventListener("keydown", handleUserActivity);
//       document.addEventListener("mousemove", handleUserActivity);
//       document.addEventListener("visibilitychange", handleVisibilityChange);

//       const handleTabClose = (event) => {
//         const currentTabCount = parseInt(localStorage.getItem("tabCount") || "1", 10);

//         if (currentTabCount <= 0) {
//           localStorage.setItem("tabCount", "0"); // Reset count
//           onSessionExpire(); // Expire session only if it's the last tab
//         } else {
//           localStorage.setItem("tabCount", (currentTabCount - 1).toString());
//         }
//       };

//       window.addEventListener("beforeunload", handleTabClose);
//       window.addEventListener("storage", (event) => {
//         if (event.key === "tabCount" && event.newValue === "0") {
//           onSessionExpire(); // If another tab set count to 0, expire session
//         }
//       });

//       return () => {
//         document.removeEventListener("keydown", handleUserActivity);
//         document.removeEventListener("mousemove", handleUserActivity);
//         document.removeEventListener("visibilitychange", handleVisibilityChange);

//         window.removeEventListener("beforeunload", handleTabClose);
//         stopTimer();
//       };
//     } else {
//       stopTimer();
//       setSessionExpire(false);
//     }
//   }, [isLoggedIn]);

//   return { sessionExpire };
// };

// export default useSessionTimeout;

// import { useState, useEffect, useRef } from "react";

// const useSessionTimeout = (
//   isLoggedIn,
//   initialTimeout = 60,
//   onSessionExpire = () => {}
// ) => {
//   const [sessionExpire, setSessionExpire] = useState(false);
//   const timeoutRef = useRef(initialTimeout);
//   const timerRef = useRef(null);

//   const resetTimer = () => {
//     if (!isLoggedIn) return;
//     timeoutRef.current = initialTimeout;
//     localStorage.setItem("lastActivity", Date.now().toString());
//     startTimer();
//   };

//   const startTimer = () => {
//     if (!isLoggedIn || timerRef.current) return;
//     stopTimer();
//     timerRef.current = setInterval(() => {
//       const lastActivity = parseInt(
//         localStorage.getItem("lastActivity") || Date.now().toString(),
//         10
//       );
//       const timeSinceLastActivity = Math.floor(
//         (Date.now() - lastActivity) / 1000
//       );

//       timeoutRef.current = initialTimeout - timeSinceLastActivity;

//       if (timeoutRef.current <= 0) {
//         clearInterval(timerRef.current);
//         timerRef.current = null;
//         setSessionExpire(true);
//         onSessionExpire();
//       }
//     }, 1000);
//   };

//   const stopTimer = () => {
//     if (timerRef.current) {
//       clearInterval(timerRef.current);
//       timerRef.current = null;
//     }
//   };

//   const handleVisibilityChange = () => {
//     if (!isLoggedIn) return;
//     if (!document.hidden) {
//       startTimer();
//     } else {
//       stopTimer();
//     }
//   };

//   useEffect(() => {
//     if (isLoggedIn) {
//       const handleUserActivity = () => resetTimer();

//       // Increase the open tab count in localStorage
//       localStorage.setItem("tabCount", (parseInt(localStorage.getItem("tabCount") || "0") + 1).toString());

//       startTimer();
//       localStorage.setItem("lastActivity", Date.now().toString());

//       document.addEventListener("keydown", handleUserActivity);
//       document.addEventListener("mousemove", handleUserActivity);
//       document.addEventListener("visibilitychange", handleVisibilityChange);

//       // When the tab is closed, decrease the open tab count
//       window.addEventListener("beforeunload", () => {
//         const currentTabCount = parseInt(localStorage.getItem("tabCount") || "1");
//         if (currentTabCount <= 1) {
//           onSessionExpire(); // Expire session only if no tabs remain
//         }
//         localStorage.setItem("tabCount", Math.max(0, currentTabCount - 1).toString());
//       });

//       return () => {
//         document.removeEventListener("keydown", handleUserActivity);
//         document.removeEventListener("mousemove", handleUserActivity);
//         document.removeEventListener("visibilitychange", handleVisibilityChange);

//         stopTimer();
//       };
//     } else {
//       stopTimer();
//       setSessionExpire(false);
//     }
//   }, [isLoggedIn]);

//   useEffect(() => {
//     const syncActivity = () => {
//       if (!isLoggedIn) return;
//       const lastActivity = parseInt(
//         localStorage.getItem("lastActivity") || Date.now().toString(),
//         10
//       );
//       const timeSinceLastActivity = Math.floor(
//         (Date.now() - lastActivity) / 1000
//       );

//       timeoutRef.current = initialTimeout - timeSinceLastActivity;

//       if (timeoutRef.current > 0) {
//         setSessionExpire(false);
//         resetTimer();
//       }
//     };

//     window.addEventListener("storage", syncActivity);

//     return () => {
//       window.removeEventListener("storage", syncActivity);
//     };
//   }, [isLoggedIn, initialTimeout]);

//   return { sessionExpire };
// };

// export default useSessionTimeout;

// import { useState, useEffect, useRef } from "react";

// const useSessionTimeout = (
//   isLoggedIn,
//   initialTimeout = 600,
//   onSessionExpire = () => {}
// ) => {
//   const [sessionExpire, setSessionExpire] = useState(false);
//   const timeoutRef = useRef(initialTimeout);
//   const timerRef = useRef(null);

//   const resetTimer = () => {
//     if (!isLoggedIn) return;
//     timeoutRef.current = initialTimeout;
//     localStorage.setItem("lastActivity", Date.now());
//     startTimer();
//   };

//   const startTimer = () => {
//     if (!isLoggedIn || timerRef.current) return;
//     stopTimer();
//     timerRef.current = setInterval(() => {
//       const lastActivity = parseInt(
//         localStorage.getItem("lastActivity") || Date.now(),
//         10
//       );
//       const timeSinceLastActivity = Math.floor(
//         (Date.now() - lastActivity) / 1000
//       );

//       timeoutRef.current = initialTimeout - timeSinceLastActivity;

//       if (timeoutRef.current <= 0) {
//         clearInterval(timerRef.current);
//         timerRef.current = null;
//         setSessionExpire(true);
//         onSessionExpire();
//       }
//     }, 1000);
//   };

//   const stopTimer = () => {
//     clearInterval(timerRef.current);
//     timerRef.current = null;
//   };

//   const handleVisibilityChange = () => {
//     if (!isLoggedIn) return;
//     if (!document.hidden) {
//       startTimer();
//     } else {
//       stopTimer();
//     }
//   };

//   useEffect(() => {
//     if (isLoggedIn) {
//       const handleUserActivity = () => resetTimer();

//       startTimer();
//       localStorage.setItem("lastActivity", Date.now());

//       document.addEventListener("keydown", handleUserActivity);
//       document.addEventListener("mousemove", handleUserActivity);
//       document.addEventListener("visibilitychange", handleVisibilityChange);

//       return () => {
//         document.removeEventListener("keydown", handleUserActivity);
//         document.removeEventListener("mousemove", handleUserActivity);
//         document.removeEventListener(
//           "visibilitychange",
//           handleVisibilityChange
//         );
//         stopTimer();
//       };
//     } else {
//       stopTimer();
//       setSessionExpire(false);
//     }
//   }, [isLoggedIn]);

//   useEffect(() => {
//     const syncActivity = () => {
//       if (!isLoggedIn) return;
//       const lastActivity = parseInt(
//         localStorage.getItem("lastActivity") || Date.now(),
//         10
//       );
//       const timeSinceLastActivity = Math.floor(
//         (Date.now() - lastActivity) / 1000
//       );

//       timeoutRef.current = initialTimeout - timeSinceLastActivity;

//       if (timeoutRef.current > 0) {
//         setSessionExpire(false);
//         resetTimer();
//       }
//     };

//     window.addEventListener("storage", syncActivity);

//     return () => {
//       window.removeEventListener("storage", syncActivity);
//     };
//   }, [isLoggedIn, initialTimeout]);

//   return { sessionExpire };
// };

// export default useSessionTimeout;
